import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RapicreditSkeletonComponent } from './rapicredit-skeleton.component';

@NgModule({
  declarations: [RapicreditSkeletonComponent],
  imports: [CommonModule],
  exports: [RapicreditSkeletonComponent],
})
export class RapicreditSkeletonModule {}
